var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"j-svg-icon-wrap"},_vm.$listeners),[_c('svg',{class:['j-svg-icon', _vm.customClass]},[_c('use',{attrs:{"xlink:href":`#icon-${_vm.name}`}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }